import { render } from "./BiaoMingView.vue?vue&type=template&id=1565958e&scoped=true&ts=true"
import script from "./BiaoMingView.vue?vue&type=script&lang=ts"
export * from "./BiaoMingView.vue?vue&type=script&lang=ts"

import "./BiaoMingView.vue?vue&type=style&index=0&id=1565958e&lang=scss&scoped=true"

import exportComponent from "C:\\vue项目\\newbdb\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1565958e"]])

export default __exports__